import { useTheme } from 'styles/colors'
import { ThemeButton } from './styled'
//import { ThemeIcon } from 'icons/themeicon'
export const ThemeToggle = () => {
  const { toggleTheme } = useTheme()
  return (
    <ThemeButton type="button" title="theme" onClick={toggleTheme}>
      {/*<ThemeIcon />*/}
      <div />
    </ThemeButton>
  )
}
